/**
 * Centralized font configuration
 * Change font files here to update throughout the application
 */

// Import font files
import FUTURAM from './assets/fonts/jost.ttf';
import NunitoSan from './assets/fonts/NunitoSan.ttf';
import HelloParisSans from './assets/fonts/HELLOPARISSANSREGULAR.TTF';

export const fonts = {
  // Primary font used throughout the application
  primary: {
    name: 'FUTURAM',
    file: FUTURAM,
    fallback: 'Montserrat, Arial, sans-serif',
  },
  // Secondary font (alternative)
  secondary: {
    name: 'NunitoSan',
    file: NunitoSan,
    fallback: 'Arial, sans-serif',
  },
  // Decorative font
  decorative: {
    name: 'HelloParisSans',
    file: HelloParisSans,
    fallback: 'Arial, sans-serif',
  },
};

// Extended unicode range to support Czech, Slovak and other Central European characters
// Slovak: á, ä, č, ď, é, í, ĺ, ľ, ň, ó, ô, ŕ, š, ť, ú, ý, ž
// Czech: ě, š, č, ř, ž, ý, á, í, é, ů, ú, ť, ď, ň
// Plus Greek, Turkish, Italian, Spanish and other extended Latin characters
export const unicodeRange = 
  'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, ' +
  'U+0100-017F, U+0180-024F, U+1E00-1EFF, ' + // Extended Latin A, B (includes Slovak/Czech diacritics)
  'U+0370-03FF, ' + // Greek
  'U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF';

export default fonts;
